import { Box, CircularProgress } from '@mui/material'
import AdxPopper from 'components/reusable/AdxPopper'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { deleteJobAds, updateJobAds } from 'services/api/modules/recruitment/job-advertisment'
import useOpenClose from 'services/hooks/useOpenClose'
import ActivateJobAdsModal from '../../recruitment-manage-applicant/components/ActivateJobAdsModal'
import ViewJobAdsDialog from './ViewJobAdsDialog'

const ActivatePopper = ({ id, goToManageApplicant }) => {
  // /navigate
  const navigate = useNavigate()
  const goToManageEditJobAds = () => {
    navigate(`/app/recruitment/applicant-tracking/job-ads/${id}/edit`, {
      state: {
        id,
      },
    })
  }
  // modal
  const cancelModal = useOpenClose(false)
  const activateModal = useOpenClose(false)
  const viewJobAdsModal = useOpenClose(false)
  const successActivateSnackbar = useOpenClose(false)
  const errorSnackbar = useOpenClose(false)

  // API CALL
  const queryClient = useQueryClient()
  const {
    isLoading: deleteLoading,
    isSuccess: deleteIsSuccess,
    error: deleteError,
    mutate: deleteMutate,
  } = useMutation((id) => deleteJobAds(id), {
    onSuccess: async () => {
      queryClient.resetQueries('getAllJobAds')
      queryClient.invalidateQueries('getAllJobAds')
    },
    onError: async (error) => {
      queryClient.invalidateQueries('getAllJobAds')
    },
  })

  const {
    isLoading: activateIsLoading,
    isSuccess: activateIsSuccess,
    error: activateError,
    data: activateData,
    isError: activateIsError,
    mutate: activateMutate,
  } = useMutation((data) => updateJobAds(id, 'activate', data), {
    onSuccess: async () => {
      queryClient.resetQueries('getAllJobAds')
      queryClient.invalidateQueries('getAllJobAds')
      successActivateSnackbar.handleOpen()
    },
    onError: async (error) => {
      queryClient.invalidateQueries('getAllJobAds')
      errorSnackbar.handleOpen()
    },
  })

  const DeleteJobAdsModal = () => (
    <Box>
      <AdxInfoModal
        variant="error"
        open={cancelModal.isOpen}
        onClose={cancelModal.handleClose}
        muiIcon="error"
        iconColor="error.main"
        title="Are you sure want to delete this?"
        subtitle="Once deleted, you can no longer retrieve this job advertisement"
        footerButtons
        firstBtnLabel={'Delete'}
        firstBtnHandle={() => deleteMutate(id)}
        secondBtnLabel={'Cancel'}
        secondBtnHandle={cancelModal.handleClose}
      />

      {deleteLoading ? (
        <AdxInfoModal
          open={cancelModal.isOpen}
          onClose={cancelModal.handleClose}
          muiIcon
          iconColor
          title={<CircularProgress />}
          subtitle
        ></AdxInfoModal>
      ) : null}

      {deleteIsSuccess ? (
        <AdxInfoModal
          variant="warning"
          open={cancelModal.isOpen}
          onClose={cancelModal.handleClose}
          muiIcon
          iconColor
          title="Delete is successful"
          subtitle
          footerButtons
          secondBtnLabel={'Close'}
          secondBtnHandle={cancelModal.handleClose}
        />
      ) : null}
    </Box>
  )

  return (
    <Box display="flex" alignItems="center" columnGap={2}>
      <AdxPopper placement="bottom-start" sx={{ marginTop: 1 }}>
        {/* <Box  onClick={()=>goToManageEditJobAds()}>
               Edit details
              </Box> */}
        <Box
          // onClick={viewJobAdsModal.handleOpen}
          onClick={() => goToManageApplicant()}
        >
          View applicant(s)
        </Box>
        <Box onClick={activateModal.handleOpen}>Re-activate job</Box>
        {/* <Box 
              sx={{
                color:"error.main"
              }}
              onClick={cancelModal.handleOpen}>
                Delete job ads
              </Box> */}
      </AdxPopper>
      {cancelModal.isOpen ? <DeleteJobAdsModal /> : null}

      {activateModal.isOpen ? (
        <ActivateJobAdsModal
          open={activateModal.isOpen}
          onClose={activateModal.handleClose}
          handleClose={activateModal.handleClose}
          mutate={activateMutate}
          isLoading={activateIsLoading}
        />
      ) : null}

      {errorSnackbar.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="error"
          TransitionComponent="slide"
          message="An error has occured. Please try again"
          open={errorSnackbar.isOpen}
          handleClose={errorSnackbar.handleClose}
        />
      ) : null}

      {successActivateSnackbar.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="success"
          TransitionComponent="slide"
          message="Job ad activated"
          open={successActivateSnackbar.isOpen}
          handleClose={successActivateSnackbar.handleClose}
        />
      ) : null}

      {viewJobAdsModal.isOpen ? (
        <ViewJobAdsDialog
          id={id}
          handleClose={viewJobAdsModal.handleClose}
          open={viewJobAdsModal.isOpen}
          data
        />
      ) : null}
    </Box>
  )
}
export default ActivatePopper
